export const environment = {
  production: true,
  apiUrl: 'https://api-ventaclick.megatecs.org',
  apiMicaChatUrl: 'https://api-mica-chat.megatecs.org',
  apiMicaChatEvolutionUrl: 'https://api-mica-chat-evo.megatecs.org',
  apiFacturacionUrl: 'https://api-facturacion.megatecs.org',
  apiReservasUrl: 'https://api-reservas.megatecs.org',
  apiPreFix: '/api',
  asyncServices: false,
  name: 'production',
  pideloPublicUrl: 'https://pidelo.megatecs.org',
  qzTrayEnabled: true,
  strongPasswordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
  locale: 'es-PE',
  igvOptions: [0.18, 0.105],
  festiveTheme: null,
};
// festive:
// null
// - fiestas-patrias
